module.exports = __webpack_public_path__ + "static/img/GL1300-FCM-SDW360-BB-2.ac10dfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GL1300-FCM-SDW360-BB-2.jpg
// module id = ZPzP
// module chunks = 0